/* D115 (31 Oct 2026): moved unchanged from sections/wwc-newsletter-popup.liquid; loaded with defer (runs after the page HTML is read). */
(function () {
  var root = document.getElementById('wwc-nl');
  if (!root || root.__wwc) return; root.__wwc = 1;
  var KEY = 'wwc_nl_popup', SUB = 'wwc_nl_subscribed', PEND = 'wwc_nl_pending';
  var d = root.dataset, loc = window.location, qs = new URLSearchParams(loc.search);
  var forced = qs.get('wwc_popup') === '1';
  var design = d.design === 'true' || (window.Shopify && Shopify.designMode);
  var panel = root.querySelector('[data-wwc-nl-panel]');
  var form = root.querySelector('form');
  var input = root.querySelector('#wwc-nl-email');
  var errEl = root.querySelector('[data-wwc-nl-err]');
  var btn = root.querySelector('[data-wwc-nl-submit]');
  var lastFocus = null, isOpen = false, shown = false, timer = null, poll = null, viaTab = false;
  var TABX = 'wwc_nl_tab_x', tab = document.querySelector('[data-wwc-nltab]'), tabMode = d.mode !== 'auto';
  /* WWC D60: phones = non-modal bottom sheet: no scroll lock, no focus trap, no focus steal; opens after 15 s or 50% scroll */
  var mob = !!(window.matchMedia && matchMedia('(max-width: 749px)').matches);
  if (mob) panel.setAttribute('aria-modal', 'false');
  var verifying = false, verifyTimer = null;   /* while Shopify's captcha runs: no focus trap, no ESC/backdrop close, no scroll lock */
  /* Draft 44 fix: never open (and steal focus) while the shopper is typing, e.g. in the header search.
     open() moves focus to the panel, so keys typed after that were lost and Enter did nothing; closing the
     popup put focus back in the search box with a truncated query that Enter then submitted. */
  var lastType = 0;
  function noteTyping(e) { if (!root.contains(e.target)) lastType = Date.now(); }
  document.addEventListener('keydown', noteTyping, true);
  document.addEventListener('input', noteTyping, true);
  document.addEventListener('compositionupdate', noteTyping, true);
  function userBusy() {
    if (Date.now() - lastType < 4000) return true;
    var a = document.activeElement;
    if (a && a !== document.body && !root.contains(a)) {
      if (a.isContentEditable || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') return true;
      if (a.tagName === 'INPUT' && !/^(hidden|button|submit|reset|checkbox|radio|image|file|range|color)$/i.test(a.type || '')) return true;
    }
    if (document.body && document.body.classList.contains('search-open')) return true;
    return !!document.querySelector('predictive-search.predictive-search-open');
  }

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---- page / visitor guards ---- */
  function hardBlocked() {   /* cart, checkout, password: never, not even with ?wwc_popup=1 */
    var p = loc.pathname.toLowerCase();
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|password|challenge)(?:\/|$)/.test(p)) return true;
    if (p.indexOf('/checkout') > -1) return true;
    if (document.body && /(^|\s)(cart|password|gift_card|captcha)-template(\s|$)/.test(document.body.className)) return true;
    if (document.body && document.body.classList.contains('password')) return true;
    return false;
  }
  function pageBlocked() {
    if (hardBlocked()) return true;
    var p = loc.pathname.toLowerCase();
    var ex = (d.exclude || '').split(',');
    for (var i = 0; i < ex.length; i++) {
      var e = ex[i].trim().toLowerCase().replace(/\/+$/, ''); if (!e) continue; if (e.charAt(0) !== '/') e = '/' + e;
      if (p === e || p.slice(-e.length) === e || p.indexOf(e + '/') > -1) return true;   /* also matches locale-prefixed paths, e.g. /en-ie/pages/contact */
    }
    if (/(^|&)contact_posted=/.test(loc.search.slice(1)) || loc.hash === '#wwc-quote') return true;
    return false;
  }
  function visitorBlocked() {
    if (ls(SUB) === '1' || d.subscribed === 'true') return true;
    var t = parseInt(ls(KEY), 10), days = parseFloat(d.days) || 30;
    return !!(t && Date.now() - t < days * 864e5);
  }
  function vis(el) {
    if (!el || el.hidden || root.contains(el)) return false;
    var s = getComputedStyle(el); if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
  }
  function anyVis(sel) { var n = document.querySelectorAll(sel); for (var i = 0; i < n.length; i++) if (vis(n[i])) return true; return false; }
  function otherModalOpen() {
    var h = document.documentElement, b = document.body;
    if (h.classList.contains('wwc-lock')) return true;                                   /* logo customiser */
    if (b && (b.classList.contains('modal-show') || b.classList.contains('modal-showing'))) return true; /* theme drawers/modals */
    if (document.querySelector('[data-wwc-por-modal]:not([hidden]), [data-wwc-modal]:not([hidden]), subscription-popup[open], dialog[open]')) return true;
    return anyVis('[aria-modal="true"]');
  }
  function cookieBannerOpen() {
    if (d.waitCookie !== 'true') return false;
    return anyVis('#shopify-pc__banner, #shopify-pc__prefs__dialog, .isense-cc-window:not(.cc-invisible), .cc-window:not(.cc-invisible), .cc-settings-dialog');
  }

  /* ---- open / close ---- */
  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
  }
  function onKey(e) {
    if (!isOpen || verifying) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || mob) return;
    var f = focusables(); if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === panel || !panel.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !panel.contains(a))) { e.preventDefault(); first.focus(); }
  }
  function lock(on) {
    if (mob) return;
    var h = document.documentElement;
    if (on) { var sw = window.innerWidth - h.clientWidth; if (sw > 0) document.body.style.paddingRight = sw + 'px'; h.classList.add('wwc-nl-lock'); }
    else { h.classList.remove('wwc-nl-lock'); document.body.style.paddingRight = ''; }
  }
  function setStep(name) {
    root.querySelectorAll('[data-wwc-nl-step]').forEach(function (s) { s.hidden = s.getAttribute('data-wwc-nl-step') !== name; });
    panel.setAttribute('aria-labelledby', name === 'success' ? 'wwc-nl-h2' : 'wwc-nl-h');
    if (name === 'success') panel.removeAttribute('aria-describedby'); else panel.setAttribute('aria-describedby', 'wwc-nl-sub');
  }
  function open(step) {
    if (isOpen) { if (step) setStep(step); return; }
    clearTimeout(timer); clearInterval(poll);
    shown = true; isOpen = true;
    if (!forced && !design && step !== 'success') ls(KEY, String(Date.now()));
    setStep(step || 'form');
    lastFocus = document.activeElement;
    root.hidden = false; root.classList.add('is-in');
    lock(true);
    document.addEventListener('keydown', onKey, true);
    if (!mob || step === 'success' || viaTab) setTimeout(function () { (step === 'success' ? root.querySelector('#wwc-nl-h2') : panel).focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (!isOpen) return;
    viaTab = false;
    isOpen = false; root.hidden = true; root.classList.remove('is-in');
    lock(false);
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  root.addEventListener('click', function (e) { if (verifying) return; if (e.target.closest('[data-wwc-nl-close]')) { e.preventDefault(); close(); } });

  /* ---- trigger: delay or exit intent, whichever first; wait while another modal / the cookie banner is open ---- */
  function trigger() {
    if (shown || pageBlocked() || visitorBlocked()) return;
    clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    var clear = 0;
    var check = function () {
      if (shown) { clearInterval(poll); return; }
      if (otherModalOpen() || cookieBannerOpen() || userBusy()) { clear = 0; return; }
      if (++clear >= 2) { clearInterval(poll); if (!visitorBlocked()) open(); }
    };
    if (!otherModalOpen() && !cookieBannerOpen() && !userBusy()) { open(); return; }
    poll = setInterval(check, 1000);
  }
  function onExit(e) { if (!e.relatedTarget && !e.toElement && e.clientY <= 0) trigger(); }

  /* ---- success / errors ---- */
  function success() {
    ls(SUB, '1'); ss(PEND, null);
    if (tab) tab.hidden = true;
    setStep('success');
    if (!isOpen) open('success'); else setTimeout(function () { root.querySelector('#wwc-nl-h2').focus({ preventScroll: true }); }, 30);
  }
  function showErr(msg) {
    errEl.textContent = msg; errEl.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus();
  }
  var btnLabel = btn.textContent;
  var TAKEN_MSG = "Looks like this email is already registered with us, so you don't need to sign up again.";

  /* Native submit: no preventDefault on a valid submit, no fetch, no form.submit(), so Shopify's own submit
     listeners (storefront reCAPTCHA token) run. The browser's required/type=email validation stops invalid
     submits before the submit event fires; we only swap the browser bubble for our own message. */
  input.addEventListener('invalid', function (e) {
    e.preventDefault();
    showErr(input.value.trim() ? 'Please enter a valid email address.' : 'Please enter your email address.');
  });
  input.addEventListener('input', function () { if (!errEl.hidden) { errEl.hidden = true; input.removeAttribute('aria-invalid'); } });
  /* Shopify bot protection (inline bootstrap in content_for_header + storefront-forms-hcaptcha):
     - it binds hCaptcha to this form lazily, on the first focusin/change inside it (or via Shopify.captcha.protect);
     - its document-level submit listener silently preventDefault()s a submit on a form that isn't bound yet
       (data-hcaptcha-bound missing), so a quick submit just did nothing;
     - once bound, its own submit listener runs hcaptcha.execute() and then submits the form natively.
     So: if the form isn't bound yet, ask Shopify to bind it and re-submit with requestSubmit() once it is. We never submit
     around the captcha. */
  var statusEl = root.querySelector('[data-wwc-nl-status]');
  function captchaApi() { return window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function' ? Shopify.captcha : null; }
  function isBound() { return form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound'); }
  var binding = false;
  function bindCaptcha(cb) {
    var api = captchaApi();
    if (!api || isBound()) { if (cb) cb(); return; }
    if (cb) form.__wwcAfterBind = cb;
    if (binding) return;
    binding = true;
    try { api.protect(form, function () { binding = false; var f = form.__wwcAfterBind; form.__wwcAfterBind = null; if (f) f(); }); }
    catch (err) { binding = false; }
  }
  input.addEventListener('focus', function () { bindCaptcha(); });   /* warm up early, same as Shopify's own focusin binding */

  function startVerifying() {
    verifying = true; root.classList.add('is-verifying');
    btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Signing you up...';   /* not disabled: Shopify re-submits with it */
    statusEl.textContent = 'Checking you\u2019re human\u2026 If a security check appears, please complete it.'; statusEl.hidden = false;
    lock(false);   /* let the page scroll so a tall hCaptcha puzzle (z-index ~2147483647, positioned in the page) can be reached */
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(stopVerifying, 20000);
  }
  function stopVerifying() {
    clearTimeout(verifyTimer); verifying = false; root.classList.remove('is-verifying');
    btn.textContent = btnLabel; btn.removeAttribute('aria-busy'); statusEl.hidden = true;
    if (isOpen) { lock(true); showErr("That didn't go through. Please try again."); }
  }
  window.addEventListener('pagehide', function () { clearTimeout(verifyTimer); });   /* navigating away = submitted */

  form.addEventListener('submit', function (e) {
    if (verifying && e.defaultPrevented) return;
    input.value = (input.value || '').trim();
    ss(PEND, String(Date.now()));             /* survives the round trip via /contact (and /challenge if Shopify shows one) */
    errEl.hidden = true; input.removeAttribute('aria-invalid');
    if (captchaApi() && !isBound()) {
      e.preventDefault();                     /* Shopify would swallow this submit anyway; re-submit once bound */
      bindCaptcha(function () { if (isBound() && form.requestSubmit) form.requestSubmit(btn); else stopVerifying(); });
    }
    if (!verifying) startVerifying();
  });

  /* ---- copy code ---- */
  var copyBtn = root.querySelector('[data-wwc-nl-copy]'), codeEl = root.querySelector('[data-wwc-nl-code]');
  function copied() { copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2500); }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    panel.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
    panel.removeChild(ta); copyBtn.focus();
    if (ok) { copied(); return; }
    var sel = window.getSelection(), rg = document.createRange(); rg.selectNodeContents(codeEl); sel.removeAllRanges(); sel.addRange(rg);
    copyBtn.textContent = 'Press Ctrl+C / Cmd+C to copy';
  }
  copyBtn.addEventListener('click', function () {
    var text = codeEl.textContent.trim();
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(copied, function () { fallbackCopy(text); });
    else fallbackCopy(text);
  });

  /* ---- side tab (default mode): the only way the form opens; no timers, no scroll/exit triggers ---- */
  function tabAllowed() {
    if (!tab || pageBlocked()) return false;
    if (ls(SUB) === '1' || d.subscribed === 'true') return false;
    var t = parseInt(ls(TABX), 10);
    return !(t && Date.now() - t < 7 * 864e5);
  }
  if (tab) {
    tab.addEventListener('click', function (e) {
      if (e.target.closest('[data-wwc-nltab-x]')) { ls(TABX, String(Date.now())); tab.hidden = true; return; }
      if (e.target.closest('[data-wwc-nltab-open]')) { viaTab = true; open('form'); }
    });
  }
  function showTab() { if (tabMode && tabAllowed()) tab.hidden = false; }

  /* ---- boot ---- */
  var q = loc.search.slice(1), pt = parseInt(ss(PEND), 10);
  var pending = !!(pt && Date.now() - pt < 30 * 60 * 1000);   /* pending flag is valid for 30 minutes */
  if (pt && !pending) ss(PEND, null);
  var mine = loc.hash === '#wwc-newsletter-popup' || pending;
  showTab();
  if (mine && (/(^|&)customer_posted=true(&|$)/.test(q) || root.querySelector('[data-wwc-nl-posted]'))) { success(); return; }
  if (mine && root.querySelector('[data-wwc-nl-error]')) {
    ss(PEND, null);
    if (root.querySelector('[data-wwc-nl-taken]')) ls(SUB, '1');
    open('form'); errEl.hidden = false; input.setAttribute('aria-invalid', 'true'); setTimeout(function () { input.focus(); }, 60); return;
  }
  /* Existing customer: Shopify returns to the page with ?form_type=customer&contact[email]=... instead of customer_posted
     (the theme's own newsletter-form in theme.js detects 'already subscribed' the same way). */
  if (mine && /(^|&)form_type=customer(&|$)/.test(q)) {
    ss(PEND, null); ls(SUB, '1');
    open('form'); showErr(TAKEN_MSG); setTimeout(function () { input.focus(); }, 60); return;
  }
  if (forced) { if (!hardBlocked()) open('form'); return; }
  if (design) {
    document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === d.section) open('form'); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === d.section) close(); });
    return;
  }
  if (tabMode) return;   /* old automatic pop-up / mobile slide-in: kept, only runs with trigger_mode = 'auto' */
  if (pageBlocked() || visitorBlocked()) return;
  if (mob) {
    timer = setTimeout(trigger, 15000);
    var onScroll = function () {
      var de = document.documentElement;
      if ((window.scrollY + window.innerHeight) / Math.max(1, de.scrollHeight) >= 0.5) { window.removeEventListener('scroll', onScroll); trigger(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  } else {
    timer = setTimeout(trigger, Math.max(1, parseFloat(d.delay) || 8) * 1000);
  }
  if (d.exit === 'true' && window.matchMedia && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onExit);
})();
